import { withLayout } from './layout';

export const inviteAdminTemplate = ({ name, email, role, tempPassword, loginUrl }) => {
  const content = `
    <h2>Admin Invitation: Sentinel Platform</h2>
    <p>Hi ${name},</p>
    <p>You have been invited as an <strong>${role}</strong> for the Sentinel Security Training platform.</p>
    <p>Your administrative account details are as follows:</p>
    <ul>
      <li><strong>Email:</strong> ${email}</li>
      <li><strong>Role:</strong> ${role}</li>
      <li><strong>Temporary Password:</strong> <span class="highlight">${tempPassword}</span></li>
    </ul>
    <p>Please log in and update your password immediately to secure your admin account.</p>
    <div style="text-align: center;">
      <a href="${loginUrl}" class="button">Access Admin Dashboard</a>
    </div>
  `;
  return withLayout(content, 'Sentinel Admin Invitation');
};